var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_setup.classes},[_c('use',{staticClass:"vac-icon__path",attrs:{"href":`${_setup.icons}#vac-ui-icon-${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }